import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Alert as BootstrapAlert } from 'reactstrap';

import { NOTIFICATION_DISMISS_TIMEOUT, ALERT_VARIANTS } from 'utils/constants';

const Alert = ({ children, variant, onClose, id, duration, ...rest }) => {
  const handleClose = () => {
    if (onClose) {
      onClose(id);
    }
  };

  return (
    <CustomAlert onClose={handleClose} color={variant} {...rest}>
      {children}
    </CustomAlert>
  );
};

const CustomAlert = styled(BootstrapAlert)`
  float: right;
  text-align: center;
  width: 100%;

  @media (min-width: 1023px) {
    width: auto;
  }
`;

Alert.propTypes = {
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  variant: PropTypes.string,
  duration: PropTypes.number,
};

Alert.defaultProps = {
  variant: ALERT_VARIANTS.SUCCESS,
  duration: NOTIFICATION_DISMISS_TIMEOUT,
  id: undefined,
  onClose: undefined,
};

export default Alert;
